import type { IconProps } from './types/types';
import IconWrapper from './wrapper/SvgIconWrapper';

const HandlerIcon = (props: IconProps) => {
  return (
    <IconWrapper {...props}>
      <rect x="6" y="2" width="1" height="12" />
      <rect x="9" y="2" width="1" height="12" />
    </IconWrapper>
  );
};

export default HandlerIcon;
